import { Route, Routes } from 'react-router-dom';
import { Keyed } from '../../shared/components/Common';
import FlightSearch from './FlightSearch';
import FlightList from './FlightList';
import FlightDetails from './FlightDetails';
import LiveFlightDetails from './LiveFlightDetails';
import FlightReview from './FlightReview';
import FlightConfirmation from './FlightConfirmation';
import FlightBookings from './FlightBookings';
import FlightBookingDetails from './FlightBookingDetails';

// Mounted at /flights/*
export default function FlightRoutes() {
  return (
    <Routes>
      <Route index element={<FlightSearch />} />
      <Route path="results" element={<Keyed page={FlightList} />} />
      <Route path="review" element={<FlightReview />} />
      <Route path="confirmation/:bookingId" element={<FlightConfirmation />} />
      <Route path="bookings" element={<FlightBookings />} />
      <Route path="bookings/:bookingId" element={<FlightBookingDetails />} />
      <Route path="live/:selectionId" element={<LiveFlightDetails />} />
      <Route path=":flightId" element={<FlightDetails />} />
    </Routes>
  );
}
